/**
 * @generated SignedSource<<fe7c63f8181dcaff111e92348b894ce2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionAcceptRulesButtonQuery$variables = {
  competition: string;
};
export type CompetitionAcceptRulesButtonQuery$data = {
  readonly viewer: {
    readonly entitiesHead: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly id: string;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserEntitiesAutocompleteFragment">;
  };
};
export type CompetitionAcceptRulesButtonQuery = {
  response: CompetitionAcceptRulesButtonQuery$data;
  variables: CompetitionAcceptRulesButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "competition"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v3 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "on",
      "variableName": "competition"
    },
    {
      "kind": "Literal",
      "name": "to",
      "value": "CREATE_COMPETITION_RULE_AGREEMENT"
    }
  ],
  "kind": "ObjectValue",
  "name": "permission"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  },
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionAcceptRulesButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": "entitiesHead",
            "args": (v4/*: any*/),
            "concreteType": "UserEntitiesConnection",
            "kind": "LinkedField",
            "name": "entities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserEntitiesAutocompleteFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionAcceptRulesButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": "entitiesHead",
            "args": (v4/*: any*/),
            "concreteType": "UserEntitiesConnection",
            "kind": "LinkedField",
            "name": "entities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              },
              (v3/*: any*/)
            ],
            "concreteType": "UserEntitiesConnection",
            "kind": "LinkedField",
            "name": "entities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20ff82c3231cea20dbfe499f8dd85249",
    "id": null,
    "metadata": {},
    "name": "CompetitionAcceptRulesButtonQuery",
    "operationKind": "query",
    "text": "query CompetitionAcceptRulesButtonQuery(\n  $competition: ID!\n) {\n  viewer {\n    id\n    username\n    entitiesHead: entities(first: 2, permission: {to: CREATE_COMPETITION_RULE_AGREEMENT, on: $competition}) {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n    ...UserEntitiesAutocompleteFragment_3ma34G\n  }\n}\n\nfragment UserEntitiesAutocompleteFragment_3ma34G on User {\n  id\n  username\n  entities(first: 10, permission: {to: CREATE_COMPETITION_RULE_AGREEMENT, on: $competition}) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd4ddb7fc505aca824597e250af60fc8";

export default node;
